import type { RootState } from 'models';

export const selectContactInfo = ({ contactInfo }: RootState) => contactInfo;
export const selectEmail = ({ contactInfo }: RootState) => contactInfo.email;
